import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEraser = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 256.00098 256",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m216.001 211.833h-95.3135l98.14258-98.1416a20.0237 20.0237 0 0 0 -.001-28.28418l-45.25486-45.25488a20.01987 20.01987 0 0 0 -28.2832 0l-56.564 56.564-.00537.00439-.00439.00537-56.564 56.564a20.02163 20.02163 0 0 0 0 28.2832l37.08887 37.08789a4.00051 4.00051 0 0 0 2.82812 1.17188h143.93075a4 4 0 0 0 0-8zm-65.05373-166.02441a12.0157 12.0157 0 0 1 16.9707 0l45.25488 45.25489a12.016 12.016 0 0 1 0 16.97168l-53.74072 53.73974-62.22559-62.22558zm-41.57422 166.02441h-35.64551l-35.918-35.916a12.01392 12.01392 0 0 1 0-16.9707l53.74072-53.74072 62.22559 62.22558z",
		fill: "currentColor"
	})
});
export default SvgEraser;
